'use client';

import * as React from 'react';
import classNames from 'classnames';
import Icon from '@/components/ui/Icon';
import './styles.scss';

export interface IListFormulasProps {
  items: {
    a: string;
    b: string;
    c: string;
    theme: 'default' | 'yellow' | 'red' | 'blue';
  }[];
}

const ListFormulas: React.FunctionComponent<IListFormulasProps> = (props) => {
  if (props.items.length === 0) {
    return null;
  }
  return (
    <ul className={'list-formulas'}>
      {props.items.map((item, itemIndex) => (
        <li
          key={itemIndex}
          className={classNames({
            ['theme-default']: item.theme === 'default',
            ['theme-red']: item.theme === 'red',
            ['theme-yellow']: item.theme === 'yellow',
            ['theme-blue']: item.theme === 'blue',
          })}
        >
          <span className={'list-formulas__a'}>{item.a}</span>
          <span className={'list-formulas__b'}>{item.b}</span>
          <span className={'list-formulas__c'}>{item.c}</span>
          <span className={'list-formulas__d'}>
            <Icon
              width={24}
              height={24}
              kind="equals"
            />
          </span>
          <span className={'list-formulas__e'}>
            <Icon
              width={24}
              height={24}
              kind="divide"
            />
          </span>
        </li>
      ))}
    </ul>
  );
};

ListFormulas.displayName = 'ListFormulas';

export default ListFormulas;
